import { IBrand } from "./IBrand";
import { IRetailMatchOverview } from "./IRetailMatch";

export interface IBrandSummaryData {
  overview: IRetailMatchOverview;
  brand: IBrand;
  tooFewRecords: boolean;
}
